import { zxcvbn } from "@zxcvbn-ts/core";
import { RnInfo, RnLightBulb } from "@remi/icons/next";
import { RemiTooltip, RemiTooltipContent, RemiTooltipTrigger, useEffect } from "@remi/next-ui";

import { cn } from "~/lib/utils";

interface PasswordStrengthProps {
  password: string;
  email?: string;
  setIsStrongEnough: (val: boolean) => void;
  className?: string;
}

export const PasswordStrength = ({ password, email, setIsStrongEnough, className }: PasswordStrengthProps) => {
  const CLERK_MINIMUM_SCORE = 3;
  const { crackTimesDisplay, feedback, score } = zxcvbn(password || "", [email || ""]);

  useEffect(() => {
    setIsStrongEnough(score >= CLERK_MINIMUM_SCORE ? true : false);
  }, [score, setIsStrongEnough]);

  return (
    <div className={cn(className, "flex items-center justify-between")}>
      <div className="flex">
        <div className="text-text-tertiary text-xs">
          <RnLightBulb size="sm" className="relative bottom-[2px] mr-1 inline" />
          Time to hack:
        </div>
        {password && (
          <div className="ml-1 text-text-secondary text-xs">
            {feedback.warning === "userInputs" ? "< 1 second" : crackTimesDisplay.onlineNoThrottling10PerSecond}
          </div>
        )}
      </div>
      {score < CLERK_MINIMUM_SCORE && (
        <RemiTooltip delayDuration={100}>
          <RemiTooltipTrigger asChild>
            <div className="text-text-destructive text-xs hover:cursor-default">
              <RnInfo size="sm" className="mr-1 ml-2 inline" />
              Help
            </div>
          </RemiTooltipTrigger>
          <RemiTooltipContent align="start" alignOffset={16}>
            <div className="text-text-primary text-xs">Try adding numbers, symbols or less common words.</div>
          </RemiTooltipContent>
        </RemiTooltip>
      )}
    </div>
  );
};
